


























































































































































































































































































































































































































































































import { Component, Vue, Mixins, Prop, Watch } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import {
  memberList,
  memberUpdate,
  resetPayPassword,
  updateVerifyStatus,
  getCountTodayMember,
  getCountVerifyStatus,
} from "@/api/vip";
import { selectAllLabel } from "@/api/discount";
// 工具
import { Decrypt, Encrypt } from "@/utils/secret";
import toFixed from "@/utils/decimal";

import copy from "@/utils/deepCopy";
import { saveUserProxy } from "@/api/userProxy";
import { deleteRelationOperationMember, relationOperationMember,selectOperation } from "@/api/operation";

interface Operation {
    operationId: Number,
    memberId: Number,
    operationSubCompany : any,
    operationService: any,
    operationMember: any,
    nickname:String
}

@Component
export default class Table extends Mixins(Loading, tablePagination) {
  @Prop() operationMemberId!: number|null;
  @Prop() serviceId!: number|null;
  @Prop() subCompanyId!: number|null;
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;
  @Prop() cardType: string = ""; //身份类型（逗号分开） 查询列表
  @Prop() recentExpenseBeginTime: string = ""; //最近的消费开始时间
  activeName: string = "2";
  activeIndex: string = "0";
  private userData2: Array<any> = [];
  private userData1: Array<any> = [];
  private userData0: Array<any> = [];
  total2: number = 0;
  total1: number = 0;
  total0: number = 0;
  imgUrl: string = "";
  dialogTitle: string = "";
  dialogVisibleUserProxy: boolean = false;
  dialogVisibleImg: boolean = false;
  userProxyForm = {
    id: Number,
    agentName: String,
    agentDesc: String,
  };
  dialogVisiblePasswd = false;
  form: { payPassword: string; id: number } = {
    payPassword: "",
    id: 0,
  };
  [propName: string]: any;
  todayMember: number = 0;
  verifyStatus: number = 0;
  dialogVisibleUserOperation: boolean = false;
  initUserOperationForm:Operation = {
    operationId: 0,
    memberId: 0,
    operationSubCompany : {},
    operationService: {},
    operationMember: {},
    nickname: ""
  };
  userOperationForm:Operation = {
    operationId: 0,
    memberId: 0,
    operationSubCompany : {},
    operationService: {},
    operationMember: {},
    nickname: ""
  };
  subCompanyList: Array<any> = [];
  serviceList: Array<any> = [];
  memberList: Array<any> = [];
  mounted() {
    this.getData();
  }

  @Watch('userOperationForm.operationSubCompany', { deep:true,immediate: true })
  toChangeSubCompany(val:any) {
    this.userOperationForm.operationService = {};
    this.userOperationForm.operationMember = {};
    this.serviceList = [];
    this.memberList = [];
  }

  @Watch('userOperationForm.operationService', { deep:true,immediate: true })
  toChangeService(val:any) {
    this.userOperationForm.operationMember = {};
    this.memberList = [];
  }

  getNew() {
    getCountTodayMember().then((res: any) => {
      this.todayMember = res.data;
    });
    getCountVerifyStatus().then((res: any) => {
      this.verifyStatus = res.data;
    });
  }

  fixedPrice(price: string | number) {
    return toFixed(price);
  }
  handleClick(val: any) {
    this.activeIndex = val.index;
    this.getData();
  }

  viewVipInfo(user: any) {
    let id = user.id;
    this.$router.push({
      path: "/vipInfo",
      query: { id: id },
    });
  }

  // 修改审核状态
  changeState(row: any, title: string, toStatus: number) {
    let word: string = "";
    switch (toStatus) {
      case 2:
        word = `是否通过 ”${row.nickname || "id：" + row.id}“ 入驻申请 ?`;
        break;
      case 3:
        word = `是否拒绝 ”${row.nickname || "id：" + row.id}“ 入驻申请 ?`;
        break;
      case 4:
        word = `是否挂起 ”${row.nickname || "id：" + row.id}“ 入驻申请 ?`;
        break;
    }
    this.$confirm(word, `${title}`, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      updateVerifyStatus({ id: row.id, status: toStatus }).then((res: any) => {
        this.$message.success("修改成功");
        this.getData();
      });
    });
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    this.getNew();
    memberList({
      cardType: this.cardType,
      recentExpenseBeginTime:
        this.recentExpenseBeginTime &&
        this.recentExpenseBeginTime.toString().split(",")[0],
      recentExpenseEndTime:
        this.recentExpenseBeginTime &&
        this.recentExpenseBeginTime.toString().split(",")[1],
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      shopName: this.shopName,
      phone: this.phone,
      userName: this.userName,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      enterStatus: this.activeName,
      operationMemberId: this.operationMemberId,
      serviceId: this.serviceId,
      subCompanyId: this.subCompanyId
    }).then((res: any) => {
      this["userData" + this.activeIndex] = res.data.list;
      this["total" + this.activeIndex] = res.data.total;
      this.hideLoading();
    });
  }
  // 预览图片
  previewPic(url: string, title: string) {
    this.dialogTitle = title;
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }
  modifyMemberProxy(row: any) {
    this.userProxyForm.id = row.id;
    this.userProxyForm.agentName = row.agentName;
    this.userProxyForm.agentDesc = row.agentDesc;
    this.dialogVisibleUserProxy = true;
  }

  modifyOperation(row: any){
      this.userOperationForm.operationId = row.operationId;
      this.userOperationForm.memberId = row.id;
      this.userOperationForm.nickname = row.nickname;
      this.dialogVisibleUserOperation = true;
  }

  async saveUserOperationInfo() {
    let operationSubCompanyId = this.userOperationForm.operationSubCompany!.id;
    let operationServiceId = this.userOperationForm.operationService!.id;
    let operationMemberId = this.userOperationForm.operationMember!.id;

    if(!operationSubCompanyId || !operationServiceId || !operationMemberId){
        this.$message.error("请选择所属分公司、服务队、运营官");
        return;
    }

    if(this.userOperationForm.operationId){
      await deleteRelationOperationMember({
        operationId: this.userOperationForm.operationId,
        memberId: this.userOperationForm.memberId
      }).catch((err: any) => {

      });
    }
    let params = {
      memberId: this.userOperationForm.memberId,
      operationSubCompanyId: operationSubCompanyId,
      operationServiceId: operationServiceId,
      operationMemberId: operationMemberId,
      operationSubCompanyName:this.userOperationForm.operationSubCompany!.roleName,
      operationServiceName:this.userOperationForm.operationService!.roleName,
      operationName:this.userOperationForm.operationMember!.roleName,
      nickname: this.userOperationForm.nickname
    }
    relationOperationMember(params).then((res: any) => {
      this.$message.success("修改成功");
      this.dialogVisibleUserOperation = false;
      this.userOperationForm = this.initUserOperationForm;
      this.getData();
    });
  }

  getSubCompany(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      roleType:2,
      roleName:str
    }).then((res: any) => {
      this.subCompanyList = res.data;
    });
  }

  getService(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      parentId:this.userOperationForm.operationSubCompany?this.userOperationForm.operationSubCompany.id:0,
      roleType:3,
      roleName:str
    }).then((res: any) => {
      this.serviceList = res.data;
    });
  }

  getMember(str:any){
    if(typeof str == 'object'){
      str = '';
    }
    selectOperation({
      parentId:this.userOperationForm.operationService?this.userOperationForm.operationService.id:0,
      roleType:4,
      roleName:str
    }).then((res: any) => {
      this.memberList = res.data;
    });
  }

  // 确认身份
  saveUserProxyInfo() {
    let params = {
      memberId: this.userProxyForm.id,
      agentName: this.userProxyForm.agentName,
      agentDesc: this.userProxyForm.agentDesc,
    };
    saveUserProxy(params).then((res: any) => {
      this.$message.success("修改成功");
      this.getData();
    });
    this.dialogVisibleUserProxy = false;
  }

  resetPasswd(row: any) {
    this.$confirm(
      `是否要重置该用户密码 ${row.nickname}   ${row.phone}`,
      "提示",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    ).then(() => {
      resetPayPassword({
        id: row.id,
      }).then((res: any) => {
        this.getData();
        this.$message.success("重置成功");
      });
    });
    // this.form.id = row.id;
    // this.dialogVisiblePasswd = true;
  }
  // 设置密码
  confirmPasswd() {
    if (this.form.payPassword.length > 0) {
      this.form.payPassword = Encrypt(this.form.payPassword);
      memberUpdate(this.form).then((res) => {
        this.$message.success("设置成功");
        this.form.payPassword = "";
        this.getData();
        this.dialogVisiblePasswd = false;
      });
    }
  }
  // 关闭修改密码对话框
  beforeClosePasswd() {
    this.form.payPassword = "";
    this.dialogVisiblePasswd = false;
  }

  // 表头样式
  headerCellStyle() {
    return {
      background: "#eef1f6",
      color: "#606266",
      textAlign: "left",
    };
  }
  // 列表样式
  cellStyle() {
    return {
      textAlign: "left",
    };
  }
}
